import { Result } from 'antd';
import React, { FC } from 'react';
import { useTypedTranslation } from 'src/hooks/useTypedTranslation';
import bgImage from './404-bg.png';
import './index.less';

const IpWhitelistError: FC = () => {
  const { t } = useTypedTranslation();

  return (
    <Result
      icon={<img src={bgImage} alt="404" className="custom-404-icon" />}
      title={t('ipWhitelist.error.title')}
      subTitle={t('ipWhitelist.error.subTitle')}
    />
  );
};

export default IpWhitelistError;

